import { ErrorMessage } from "../../enums/error-message";
import { ValidationError } from "../validation-error";
export class SnakeCaseValidator {
    validate(messageToTest) {
        if (typeof messageToTest !== 'string' ||
            messageToTest !== messageToTest.toLowerCase() ||
            (messageToTest.includes('-') && !messageToTest.includes('-1'))) {
            throw new ValidationError(ErrorMessage.INVALID_SNAKE_CASE);
        }
    }
}
